import getFailedAnswersFromLocal from './getFailedAnswersFromLocal';

export default function getAnswers(formId) {
  return new Promise((resolve) => {
    getFailedAnswersFromLocal(formId)
      .then((answers) => {
        if (answers === undefined) resolve({});
        resolve(answers);
      })
      .catch(() => {
        resolve({});
      });
  });
}
